import { render, staticRenderFns } from "./index.vue?vue&type=template&id=87b43dae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=87b43dae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b43dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87b43dae')) {
      api.createRecord('87b43dae', component.options)
    } else {
      api.reload('87b43dae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=87b43dae&scoped=true", function () {
      api.rerender('87b43dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/synchronization/index.vue"
export default component.exports